<template>
  <section class="content">
    <div class="container-fluid">
      <loader v-if="loading" :type="'table'"/>
      <div v-else>
        <div class="row">
            <div class="col-12">
              <h1>{{translate('messages.categories')}}</h1>
            </div>
        </div>
        <div class="row">

          <div class="col-12">
        
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">{{translate('messages.marker_category_list')}}</h3>

                <div class="card-tools">
                  
                  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      {{translate('messages.add_new_a')}}
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>{{translate('messages.name')}}</th>
                      <th>{{translate('messages.description')}}</th>
                      <th>{{translate('messages.actions')}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="marker_category in marker_categories.data" :key="'marker-category-'+marker_category.id">
                      <td>{{marker_category.name}}</td>
                      <td v-if="marker_category.description">{{marker_category.description}}</td>
                      <td v-else></td>
                      <td>
                        <a @click="editModal(marker_category)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.update')" data-toggle="tooltip">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        
                        <a @click="deleteMarkerCategory(marker_category.id)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.delete')" data-toggle="tooltip">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="!marker_categories.data.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="marker_categories" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>
      </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">{{translate('messages.create_marker_category')}}</h5>
                    <h5 class="modal-title" v-show="editmode">{{translate('messages.update_marker_category')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateMarkerCategory() : createMarkerCategory()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>{{translate('messages.name')}}</label>
                            <input v-model="form.name" type="text" name="name"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>{{translate('messages.description')}}</label>
                            <input v-model="form.description" type="text" name="description"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('description') }">
                            <has-error :form="form" field="description"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{translate('messages.close')}}</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">{{translate('messages.update')}}</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">{{translate('messages.create')}}</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                editmode: false,
                marker_categories : {},
                form: new Form({
                    id : '',
                    name: '',
                    description: '',
                }),
                loading : true,
                page : 1
            }
        },
        methods: {

            getResults(page = 1) {

                this.$Progress.start();
                this.page = page;
                axios.get('/api/markerCategory?page=' + page).then(({ data }) => {
                  this.marker_categories = data.data;
                  this.loading = false;
                  this.$root.$emit('updateMarkersNavbar');
                  this.$Progress.finish();
                  if(!this.marker_categories.data.length && this.page > 1){
                    this.getResults(this.page - 1);
                  }
                });

            },
            updateMarkerCategory(){
                this.$Progress.start();
                this.form.update({_method:'put'});
                this.form.post('/api/markerCategory/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                    this.getResults(this.page);
                })
                .catch(() => {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                        icon: 'error',
                        title: error_title
                    });
                    this.$Progress.fail();
                });

            },
            editModal(category){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(category);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },            
            createMarkerCategory(){
                this.$Progress.start();
                this.form.update({_method:'post'});
                this.form.post('/api/markerCategory')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });

                    this.$Progress.finish();
                    this.getResults();
                })
                .catch((error)=>{
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                        icon: 'error',
                        title: error_title
                    });
                    this.$Progress.fail();
                })
            },
            deleteMarkerCategory(id){
              Swal.fire({
              title: window.translate('messages.are_you_sure'),
              text: window.translate('messages.no_revert'),
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              cancelButtonText: window.translate('messages.cancel'),
              confirmButtonText: window.translate('messages.delete_confirm')
              })
              .then((result) => {
                // Send request to the server
                if (result.value) {
                  this.$Progress.start();
                  this.form.delete('/api/markerCategory/'+id).then((response)=>{
                    this.$Progress.finish();
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    // Fire.$emit('AfterCreate');
                    this.getResults(this.page);
                  }).catch((error)=> {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                      icon: 'error',
                      title: error_title
                    });
                    this.$Progress.fail();
                  });
                }
              })
          },

        },
        mounted() {
          
        },
        created() {
            this.getResults(); 
        }
    }
</script>
